export default function parseIntFromStr(str){
    return parseInt(str, 10);
}